var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16675 10.8327C3.0114 6.69878 6.14169 3.38945 10.1901 2.26327C10.5299 2.16873 10.6999 2.12147 10.7914 2.22274C10.8829 2.32401 10.8155 2.49147 10.6806 2.82637L9.75008 4.87435M15.1667 2.16602C19.3006 3.01067 22.61 6.14096 23.7361 10.1894C23.8307 10.5292 23.8779 10.6991 23.7766 10.7906C23.6755 10.8822 23.508 10.8147 23.173 10.6799L21.1251 9.74935M23.8334 15.166C22.9887 19.2999 19.8584 22.6093 15.81 23.7354C15.4702 23.83 15.3003 23.8772 15.2088 23.7759C15.1172 23.6747 15.1847 23.5072 15.3195 23.1723L16.2501 21.1243M10.8334 23.8327C6.69951 22.988 3.39018 19.8577 2.264 15.8093C2.16947 15.4695 2.1222 15.2996 2.22347 15.208C2.32474 15.1165 2.4922 15.184 2.8271 15.3188L4.87508 16.2493",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33054 12.6374L13.1213 7.77168C13.4178 7.39114 13.9734 7.62799 13.9734 8.13489V11.9011C13.9734 12.2047 14.1914 12.4509 14.4601 12.4509H16.3039C16.7227 12.4509 16.946 13.0087 16.6693 13.3639L12.8786 18.2296C12.5821 18.6101 12.0264 18.3733 12.0264 17.8664V14.1002C12.0264 13.7966 11.8085 13.5504 11.5397 13.5504H9.69595C9.27711 13.5504 9.05384 12.9926 9.33054 12.6374Z",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewal1);
export default __webpack_public_path__ + "static/media/renewal (1).617bd7358a77cd2aebfd30a8a06a2829.svg";
export { ForwardRef as ReactComponent };